import { MessageDescriptor } from "react-intl";

import {Option} from "../../DefaultSettings/Settings/FieldWrapper";
import { AlarmFilterEnum } from '../AlarmFilterEnum';
import { OrderFilterEnum } from '../OrderFilterEnum';
import { DeviceHardwareEnum, isGx8 } from '../../DeviceHardwareEnum';
import { LabelEnum } from '../LabelEnum';
import { StatusEnum } from "@Safemate/Dashboard/StatusEnum";

export type GetAlarmFilter = (
  deviceTypes: DeviceHardwareEnum[], 
  formatMessage: (message: MessageDescriptor) => string
) => Option[];

export type GetOrderFilter = (
  formatMessage: (message: MessageDescriptor) => string
) => Option[];

export type TranslateDeviceTypes = (
  deviceTypes: Option[], 
  formatMessage: (message: MessageDescriptor) => string
) => Option[];


export const getAlarmFilter: GetAlarmFilter = (deviceTypes, formatMessage) => {
  if(deviceTypes.length === 1 && isGx8(deviceTypes[0])){
    return[
      {text: formatMessage({id: LabelEnum.ALARM, defaultMessage: "Alarm"}), value: AlarmFilterEnum.ALARM},
      {text: formatMessage({id: StatusEnum.FIRE_WARNING, defaultMessage: "Fire"}), value: AlarmFilterEnum.FIRE},
      {text: formatMessage({id: LabelEnum.LOW_BATTERY, defaultMessage: "Lavt Batteri"}), value: AlarmFilterEnum.BATTERY},
      {text: formatMessage({id: LabelEnum.SELFCHECK, defaultMessage: "Selfcheck"}), value: AlarmFilterEnum.SELFCHECK},
      {text: formatMessage({id: LabelEnum.OFFLINE, defaultMessage: "Offline"}), value: AlarmFilterEnum.OFFLINE},
      {text: formatMessage({id: StatusEnum.TCP_STATUS_DISABLED_WARNING, defaultMessage: "TCP offline"}), value: AlarmFilterEnum.TCP_DISABLED},
      {text: formatMessage({id: LabelEnum.UNKNOWN, defaultMessage: "Unknown"}), value: AlarmFilterEnum.NEVER_USED},
      {text: formatMessage({id: "sensorSupervisionFailure", defaultMessage: "Sensor failet selvsjekk"}), value: AlarmFilterEnum.SENSOR_SUPERVISION_FAILURE},
      {text: formatMessage({id: "sensorTamper", defaultMessage: "Sabotasje"}), value: AlarmFilterEnum.SENSOR_TAMPER},
      {text: formatMessage({id: "sensorLowBattery", defaultMessage: "Sensor lavt batteri"}), value: AlarmFilterEnum.SENSOR_LOW_BATTERY},
      {text: formatMessage({id: LabelEnum.OK, defaultMessage: "OK"}), value: AlarmFilterEnum.OK}
    ]
  }
  const filters = [
    {text: formatMessage({id: LabelEnum.ALARM, defaultMessage: "Alarm"}), value: AlarmFilterEnum.ALARM},
    {text: formatMessage({id: LabelEnum.GEOFENCE, defaultMessage: "Geofence"}), value: AlarmFilterEnum.GEOFENCE},
    {text: formatMessage({id: LabelEnum.OUT_OF_BATTERY, defaultMessage: "Battery Empty"}), value: AlarmFilterEnum.OUT_OF_BATTERY},
    {text: formatMessage({id: LabelEnum.LOW_BATTERY, defaultMessage: "Lavt Batteri"}), value: AlarmFilterEnum.BATTERY},
    {text: formatMessage({id: LabelEnum.STATIC, defaultMessage: "Static"}), value: AlarmFilterEnum.STATIC},
    {text: formatMessage({id: LabelEnum.SELFCHECK, defaultMessage: "Selfcheck"}), value: AlarmFilterEnum.SELFCHECK},
    {text: formatMessage({id: LabelEnum.OUTDATEDPOSITION, defaultMessage: "Outdated Position"}), value: AlarmFilterEnum.OUTDATED_POSITION},
    {text: formatMessage({id: StatusEnum.TCP_STATUS_DISABLED_WARNING, defaultMessage: "TCP offline"}), value: AlarmFilterEnum.TCP_DISABLED},
    {text: formatMessage({id: LabelEnum.OFFLINE, defaultMessage: "Offline"}), value: AlarmFilterEnum.OFFLINE},
  ]

  if(deviceTypes.find(dt => isGx8(dt))){
    filters.push(
      {text: formatMessage({id: "acFail", defaultMessage: "Strømfeil"}), value: AlarmFilterEnum.AC_FAIL},
      {text: formatMessage({id: "sensorSupervisionFailure", defaultMessage: "Sensor failet selvsjekk"}), value: AlarmFilterEnum.SENSOR_SUPERVISION_FAILURE},
      {text: formatMessage({id: "sensorTamper", defaultMessage: "Sabotasje"}), value: AlarmFilterEnum.SENSOR_TAMPER},
      {text: formatMessage({id: "sensorLowBattery", defaultMessage: "Sensor lavt batteri"}), value: AlarmFilterEnum.SENSOR_LOW_BATTERY}
    );
  }

  filters.push(
    {text: formatMessage({id: LabelEnum.UNKNOWN, defaultMessage: "Unknown"}), value: AlarmFilterEnum.NEVER_USED},
    {text: formatMessage({id: LabelEnum.OK, defaultMessage: "OK"}), value: AlarmFilterEnum.OK}
  );
  
  return filters;
}

export const getOrderFilter: GetOrderFilter = (formatMessage) => {
  return[
    {text: capitalizeLabel(formatMessage({id: LabelEnum.DEVICE_LIST_SORT_PRO, defaultMessage: "Standardsortering"})), value: OrderFilterEnum.DEFAULT},
    {text: capitalizeLabel(formatMessage({id: LabelEnum.LAST_CONTACT_ASC, defaultMessage: "Siste kontakt - Stigende"})), value: OrderFilterEnum.LAST_CONTACT_ASC},
    {text: capitalizeLabel(formatMessage({id: LabelEnum.LAST_CONTACT_DESC, defaultMessage: "Siste kontakt - Synkende"})), value: OrderFilterEnum.LAST_CONTACT_DESC},
    {text: capitalizeLabel(formatMessage({id: LabelEnum.NAME, defaultMessage: "Navn"})), value: OrderFilterEnum.NAME},
    {text: capitalizeLabel(formatMessage({id: LabelEnum.NOTES_ADDED_DESC, defaultMessage: "Notat - Synkende"})), value: OrderFilterEnum.NOTES_ADDED_DESC},
    {text: capitalizeLabel(formatMessage({id: LabelEnum.BATTERY_DESC, defaultMessage: "Batterinivå - synkende"})), value: OrderFilterEnum.BATTERY_DESC},
    {text: capitalizeLabel(formatMessage({id: LabelEnum.PHONE_NUMBER, defaultMessage: "Telefonnummer"})), value: OrderFilterEnum.PHONE_NUMBER},
  ]
}

type CapitalizeLabel = (label: string) => string;

const capitalizeLabel: CapitalizeLabel = (label) => {
  return `${label.charAt(0).toUpperCase()}${label.substr(1, label.length - 1)}`;
}

export const translateDeviceTypes: TranslateDeviceTypes = (deviceTypes, formatMessage) => {
  return deviceTypes.map(option => {
    return {
      text: formatMessage({id: `deviceHardware${option.value}`, defaultMessage: option.text}),
      value: option.value
    }
  });
}
